import { render, staticRenderFns } from "./ModalText.vue?vue&type=template&id=b06c3c62&scoped=true&"
import script from "./ModalText.vue?vue&type=script&lang=js&"
export * from "./ModalText.vue?vue&type=script&lang=js&"
import style0 from "./ModalText.vue?vue&type=style&index=0&id=b06c3c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c3c62",
  null
  
)

export default component.exports